<template>
  <div style="background:#f6f7fa;">
    <Header></Header>
    <div class="mt-3 mb-3">
      <div class="container p-2">
        <section
          class="news_content"
          style="margin: 0px; padding:3rem 4rem; overflow: hidden; color: rgb(51, 51, 51);  text-align:left; background-color:#FFF;"
        >
          <h3
            style="margin-bottom:2rem; padding-bottom:1rem;font-size: 28px; font-weight: lighter; text-align: center; border-bottom: 1px solid rgb(138, 172, 220);"
          >
            联系方式
          </h3>
          <pre
            style=" line-height:2; white-space: pre-wrap; overflow-wrap: break-word;"
          >
          王女士
          电话：010-58582486
          邮箱：<a href="mailto:wangshh1@hep.com.cn">wangshh1@hep.com.cn</a>
          </pre>
        </section>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Header from "../components/header";
import Bottom from "../components/bottom";
export default {
  data() {
    return {};
  },
  components: {
    Header,
    Bottom,
  },
};
</script>

<style>
@import url("../assets/style.css");
@import url("../assets/bootstrap.css");
pre {
  font-size: 100%;
  text-align: justify;
}
</style>
